exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.assets-select__select[data-v-3ce92c0d] {\n  width: 70px;\n  margin-bottom: 0;\n}\n.assets-select__select[data-v-3ce92c0d]:not(:last-child) {\n    margin-right: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ce92c0d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/trade/index/components/chart/ChartWidget.AssetsSelect.vue
// module id = SRnJ
// module chunks = 1